import React, { useEffect, useState } from 'react';
import Modal from '../../../ui/Modal';

const API = process.env.REACT_APP_API_URL;
const KZT = new Intl.NumberFormat('ru-KZ', { maximumFractionDigits: 2 });

const fmtDate = (s) => {
  if (!s) return '—';
  const d = new Date(s);
  return isNaN(d.getTime()) ? '—' : d.toLocaleDateString('ru-RU');
};

const paymentStatus = (id) => {
  const n = Number(id);
  if (n === 1) return 'Ожидает оплаты';
  if (n === 2) return 'Оплачен';
  return '—';
};

function StatusBadge({ name }) {
  const n = String(name || '').toLowerCase();
  let tone = 'neutral';
  if (/ожидает|новая/.test(n))           tone = 'warning';
  else if (/подтверждена|готов|оплачен|доставлен|закрыт|завершен/.test(n)) tone = 'success';
  else if (/отмен|возврат|отклон/.test(n))     tone = 'danger';
  else if (/в пути|производ|собира|на доставке/.test(n)) tone = 'info';
  return <span className={`crmpage__status crmpage__status--${tone}`}>{name || '—'}</span>;
}

const OrderQuickView = ({ isOpen, onClose, row }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen || !row) return;
    const orderId = row.id_orders || row.id;
    if (!orderId) return;
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        const r = await fetch(`${API}v1/order_view`);
        const all = await r.json();
        const mine = Array.isArray(all) ? all.filter((o) => Number(o.id_orders) === Number(orderId)) : [];
        if (!cancelled) setItems(mine);
      } catch (e) {
        console.error(e);
        if (!cancelled) setItems([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [isOpen, row]);

  if (!row) return null;

  const total = items.reduce(
    (sum, it) => sum + Number(it.product_price || it.price || 0) * Number(it.quantity || 0),
    0,
  );
  const displayTotal = row.total_amount ? Number(row.total_amount) : total;

  return (
    <Modal
      isOpen={!!isOpen}
      onClose={onClose}
      title={`Заказ №${row.order_number || row.id}`}
      subtitle={`от ${fmtDate(row.order_date)}`}
      size="lg"
    >
      <div className="uimodal-field">
        <span className="uimodal-field__label">Клиент</span>
        <span className="uimodal-field__value">{row.client_name || '—'}</span>
      </div>
      <div className="uimodal-field">
        <span className="uimodal-field__label">Договор</span>
        <span className="uimodal-field__value">{row.contract_info || row.contract_number || '—'}</span>
      </div>
      <div className="uimodal-field">
        <span className="uimodal-field__label">Адрес доставки</span>
        <span className="uimodal-field__value">{row.delivery_address || '—'}</span>
      </div>

      <div className="uimodal-grid-2">
        <div>
          <span className="uimodal-field__label">Регион</span>
          <span className="uimodal-field__value">{row.region_name || '—'}</span>
        </div>
        <div>
          <span className="uimodal-field__label">Дата доставки</span>
          <span className="uimodal-field__value">{fmtDate(row.delivery_date)}</span>
        </div>
      </div>

      <div className="uimodal-grid-2">
        <div>
          <span className="uimodal-field__label">Экспедитор</span>
          <span className="uimodal-field__value">{row.expediter || row.full_name || row.driver_name || '—'}</span>
        </div>
        <div>
          <span className="uimodal-field__label">Транспорт</span>
          <span className="uimodal-field__value">{row.vname || row.vehicle_name || '—'}</span>
        </div>
      </div>

      <div className="uimodal-grid-2">
        <div>
          <span className="uimodal-field__label">Статус заказа</span>
          <span className="uimodal-field__value"><StatusBadge name={row.status_name} /></span>
        </div>
        <div>
          <span className="uimodal-field__label">Статус оплаты</span>
          <span className="uimodal-field__value"><StatusBadge name={paymentStatus(row.id_payment_status)} /></span>
        </div>
      </div>

      {row.client_commentary && (
        <div className="uimodal-field">
          <span className="uimodal-field__label">Комментарий клиента</span>
          <span className="uimodal-field__value">{row.client_commentary}</span>
        </div>
      )}

      <table className="uimodal-table">
        <thead>
          <tr>
            <th>Товар</th>
            <th>Ед.</th>
            <th className="num">Кол-во</th>
            <th className="num">Цена</th>
            <th className="num">Сумма</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr><td colSpan={5} style={{ textAlign: 'center', padding: 20, color: '#8C8077' }}>Загрузка…</td></tr>
          ) : items.length > 0 ? items.map((it, i) => {
            const q = Number(it.quantity || 0);
            const p = Number(it.product_price || it.price || 0);
            return (
              <tr key={i}>
                <td>{it.product_name || it['Товар'] || '—'}</td>
                <td>{it.measure_name || ''}</td>
                <td className="num">{q}</td>
                <td className="num">{KZT.format(p)} ₸</td>
                <td className="num">{KZT.format(q * p)} ₸</td>
              </tr>
            );
          }) : (
            <tr><td colSpan={5} style={{ textAlign: 'center', padding: 20, color: '#8C8077' }}>По заказу нет позиций</td></tr>
          )}
        </tbody>
      </table>

      <div className="uimodal-total">
        <span className="uimodal-total__label">Итого по заказу</span>
        <span className="uimodal-total__value">{KZT.format(displayTotal)} ₸</span>
      </div>
    </Modal>
  );
};

export default OrderQuickView;
